export default __webpack_public_path__ + "static/media/1-API.49c8aa19.jpeg";